export function Wordmark({ size = "lg" }: { size?: "sm" | "md" | "lg" }) {
  const cls =
    size === "lg"
      ? "text-5xl"
      : size === "md"
        ? "text-3xl"
        : "text-xl";
  return (
    <div className={`flex items-baseline gap-2 ${cls} font-bold tracking-tight`}>
      <span className="text-navy">Orbit</span>
      <span className="text-amber italic font-medium">by M42</span>
    </div>
  );
}

export function BrandIcon({ size = 48 }: { size?: number }) {
  return (
    <img
      src="/icons/orbit-icon-192.png"
      alt="Orbit logo"
      width={size}
      height={size}
      className="rounded-full"
    />
  );
}
